/*
 * @Author: Json Chen
 * @Date: 2021-09-27 18:49:00
 * @LastEditTime: 2022-06-15 18:00:06
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/DirectDiscount/Detail/OrderEligible/index.tsx
 */
import React from 'react';
import SectionWrapper from 'src/pages/SalesCannelVersion/Components/SectionWrapper';
import OrderEligible from 'src/pages/SalesCannelVersion/SalesChannelDiscounts/Components/OrderEligibleCondition';
import css from './css.module.less';
// const Item = Form.Item;
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const OrderEligibleSection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };

  const { form, currency, disableEdit } = props;
  return (
    <SectionWrapper
      containerClassName={css.sectionContainer}
      title={getI18n(
        'salesChannelDirectDiscount.orderEligibleSection.orderEligibleCondition',
      )}
      subtitle={getI18n(
        'salesChannelDirectDiscount.eligibalCondition.conditionTip',
      )}>
      <OrderEligible
        name={'conditions'}
        form={form}
        currency={currency}
        disableEdit={disableEdit}
      />
    </SectionWrapper>
  );
};

export default OrderEligibleSection;
